module.exports = __webpack_public_path__ + "img/1527487420.8bc3dda1.jpg";